import { useState } from 'react';
import type { Dispatch} from 'umi';
import { connect, useIntl } from 'umi';
import { Drawer, Space } from 'antd';
import IconFont from '@/components/IconFont';

import type { InquiryState } from '@/models/inquiry';
import InquiryAvatar from '../InquiryAvatar';
import styles from './index.less';


interface InquiryHeadertProps {
  inquiry: InquiryState;
  dispatch: Dispatch;
  drawerContainerRef: React.RefObject<HTMLElement>;
};

const InquiryHeader: React.FC<InquiryHeadertProps> = ({
  inquiry,
  dispatch,
  drawerContainerRef
}) => {
  // 国际化
  const intl = useIntl();
  const c = window.$tc('', intl.formatMessage);
  const t = window.$tc('component.Inquiry.InquiryHeader', intl.formatMessage);

  const [drawerVisible, setDrawerVisible] = useState<boolean>(false);

  return (
    <>
      <div className={styles.inquiryHeader}>
        <span>{inquiry.currentInquiry?.familyInfo?.name}</span>
        <IconFont
          className={styles.icon}
          type="icon-idcard"
          onClick={() => setDrawerVisible(true)}
        />
      </div>

      <Drawer
        title={t('t0', "客户信息")}
        visible={drawerVisible}
        onClose={() => setDrawerVisible(false)}
      >
        <Space align="center" style={{ marginBottom: '1em' }}>
          <InquiryAvatar text={inquiry.currentInquiry?.familyInfo?.name}/>
          <span>{inquiry.currentInquiry?.familyInfo?.name}</span>
        </Space>
        <p>{t('t1', '年龄：')}{inquiry.currentInquiry?.familyInfo?.age}{t('t2', '岁')}</p>
        <p>{t('t3', '性别：')}{inquiry.currentInquiry?.familyInfo?.sex}</p>
        <p>{t('t4', '手机号：')}{inquiry.currentInquiry?.familyInfo?.mobile}</p>
      </Drawer>
    </>
  )
};

const mapToProps = ({ inquiry }: { inquiry: InquiryState }) => {
  return {
    inquiry
  }
}
                  
export default connect(mapToProps)(InquiryHeader);
